import { render, staticRenderFns } from "./CookiesTooltip.vue?vue&type=template&id=07f40d1e&scoped=true&"
import script from "./CookiesTooltip.vue?vue&type=script&lang=js&"
export * from "./CookiesTooltip.vue?vue&type=script&lang=js&"
import style0 from "./CookiesTooltip.vue?vue&type=style&index=0&id=07f40d1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f40d1e",
  null
  
)

export default component.exports